import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';
import dollarfy from '../Support/Dollarfy';

const trayTable = (props) => {

	if(!props.data) return null;

	let r = 0;
	let total = 0;
	let rows = Object.keys(props.data)
		.map(row => {

			const m = props.data[row];
			r += 1;
			total += +m.value;

			return (
				<tr key={m.id}>
					<td className='mtable__c1 blankish'>&nbsp;</td>
					<td className='mtable__c2 blankish'>&nbsp;</td>
					<td className='mtable__c3'>{r}</td>
					<td className='mtable__c4'><span className='align-input'>{m.description}</span></td>
					<td className='mtable__c5'><input type='number' placeholder='0' value={+m.value === 0 ? '' : m.value} onChange={
						(event) => {props.rdxEditListValue(props.id,row,'value',event.target.value)}} /></td>
					<td className='mtable__c6'>&nbsp;</td>
				</tr>
			);

		});

	let footer = null;
	if(rows.length > 1)
		footer = (
			<tfoot>
				<tr>
					<td className='blankish' colSpan='2'>&nbsp;</td>
					<td>&nbsp;</td>
					<td className='mtable__f2' colSpan='2'>SUBTOTAL <span>{dollarfy(total)}</span></td>
					<td className='blankish'>&nbsp;</td>
				</tr>
			</tfoot>
		);

	return (
		<div className='traytable'>
			<table className='mtable'>
				<thead>
					<tr>
						<th className='blankish' colSpan='2'>Options</th>
						<th className='align-center'><span className='mtable__thead__extra'>Claim </span>#</th>
						<th><span className='align-input'>Description</span></th>
						<th className='align-right'><span className='align-input'>Amount<span className='mtable__thead__extra'> ($)</span></span></th>
						<th className='blankish'>&nbsp;</th>
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
				{footer}
			</table>
		</div>
	);

}

const mapDispatchToProps = dispatch => {
	return {
		rdxEditListValue: (id,row,item,value) => 		dispatch(actions.editListValue(id,row,item,value))
	};
}



export default connect(null, mapDispatchToProps)(trayTable);


// WEBPACK FOOTER //
// ./src/UI/TrayTable.js